import React from 'react';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  image: string;
  overlayOpacity?: string;
  height?: string;
  waveColor?: string;
}

export const PageHero: React.FC<PageHeroProps> = ({ 
  title, 
  subtitle, 
  image,
  overlayOpacity = "opacity-40",
  height = "h-[50vh] min-h-[400px]",
  waveColor = "fill-simba-cream"
}) => {
  return (
    <div className={`relative ${height} flex items-center justify-center overflow-hidden`}>
      {/* Background Image with Parallax-like fix */}
      <div className="absolute inset-0 z-0">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover transform scale-105"
        />
        <div className={`absolute inset-0 bg-simba-dark ${overlayOpacity}`}></div>
        <div className="absolute inset-0 bg-gradient-to-t from-simba-dark/80 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <h1 className="font-display font-bold text-5xl md:text-6xl text-white mb-6 drop-shadow-xl">
          {title}
        </h1>
        {subtitle && (
          <p className="font-body text-xl md:text-2xl text-simba-cream/90 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
            {subtitle}
          </p>
        )}
      </div>

      {/* Decorative Bottom Curve - Matching the brand style */}
      <div className="absolute -bottom-[1px] left-0 w-full leading-none z-20">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className={waveColor}>
          <path fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
        </svg>
      </div>
    </div>
  );
};
